var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 37.5781C29.7081 37.5781 37.5781 29.7081 37.5781 20C37.5781 10.2919 29.7081 2.42188 20 2.42188C10.2919 2.42188 2.42188 10.2919 2.42188 20C2.42188 29.7081 10.2919 37.5781 20 37.5781Z",
    fill: "url(#paint0_linear_4634_10129)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7344 10.2344H16.2734C12.9453 10.2344 10.2422 12.9375 10.2422 16.2656V23.7266C10.2422 27.0547 12.9453 29.7578 16.2734 29.7578H23.7344C27.0625 29.7578 29.7656 27.0547 29.7656 23.7266V16.2656C29.7656 12.9375 27.0625 10.2344 23.7344 10.2344ZM27.5859 23.7344C27.5859 25.8594 25.8594 27.5938 23.7266 27.5938H16.2656C14.1406 27.5938 12.4062 25.8672 12.4062 23.7344V16.2734C12.4062 14.1484 14.1328 12.4141 16.2656 12.4141H23.7266C25.8516 12.4141 27.5859 14.1406 27.5859 16.2734V23.7344Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.0078C17.25 15.0078 15.0078 17.25 15.0078 20C15.0078 22.75 17.25 24.9922 20 24.9922C22.75 24.9922 24.9922 22.75 24.9922 20C24.9922 17.25 22.75 15.0078 20 15.0078ZM20 23.0312C18.3281 23.0312 16.9687 21.6719 16.9687 20C16.9687 18.3281 18.3281 16.9687 20 16.9687C21.6719 16.9687 23.0312 18.3281 23.0312 20C23.0312 21.6719 21.6719 23.0312 20 23.0312Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3723 15.555C25.8322 15.4804 26.1446 15.0471 26.0701 14.5872C25.9955 14.1273 25.5622 13.8149 25.1023 13.8894C24.6424 13.964 24.33 14.3973 24.4045 14.8572C24.4791 15.3171 24.9124 15.6295 25.3723 15.555Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4634_10129",
    x1: 6.61555,
    y1: 33.3845,
    x2: 31.596,
    y2: 8.40398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518459,
    stopColor: "#FEDB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#FEC125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#FE983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#FE5F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000DC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a277a36eda4ba998f8e7868d46e39a97.svg";
export { ForwardRef as ReactComponent };